module.exports = __webpack_public_path__ + "static/media/Anamikaa.d2586bd4.jpg";